import React, { useState, useEffect } from "react";
import { Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faTimes } from "@fortawesome/free-solid-svg-icons";
import { cancelRequest } from "../../../../utils/queries";
import "../../../molecules/BrandModal.css";

export const RequestModal = ({ toggle, setToggle, account, onUpdateRequest }) => {
  const [reason, setReason] = useState("");
  const [showAdditionalError, setShowAdditionalError] = useState(false);

  // Pre-populate with existing cancellation reason if present
  useEffect(() => {
    if (account?.cancelledByReason) {
      setReason(account.cancelledByReason);
    }
  }, [account]);

  const close = () => setToggle(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!reason.trim()) {
      setShowAdditionalError(true);
      return;
    }

    try {
      await cancelRequest(account.id, reason);
      close();
      onUpdateRequest({ ...account, status: "Cancelled", cancelledByReason: reason });
    } catch (err) {
      // surface error to parent? for now just close
    }
  };

  return (
    <Modal isOpen={toggle} toggle={close} className="brand-modal">
      <ModalHeader toggle={close}>Cancel Request</ModalHeader>
      <ModalBody>
        <p className="brand-modal__desc">Please provide a reason for cancelling this request.</p>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label for="cancelReason">Reason</Label>
            <Input
              type="textarea"
              id="cancelReason"
              placeholder="Reason for cancelling request required"
              value={reason}
              onChange={(e) => {
                setReason(e.target.value);
                if (e.target.value.trim()) setShowAdditionalError(false);
              }}
            />
            {showAdditionalError && (
              <p className="text-danger">Required</p>
            )}
          </FormGroup>

          <div className="brand-modal__actions">
            <button type="submit" className="brand-modal__btn brand-modal__btn--danger">
              <FontAwesomeIcon icon={faBan} /> Mark as cancelled
            </button>
            <button type="button" className="brand-modal__btn brand-modal__btn--cancel" onClick={close}>
              <FontAwesomeIcon icon={faTimes} /> Close
            </button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};
